import cn from "@utils/cn";
import { FC } from "react";

import Radio from "@/components/ui/Form/Radio/Radio";
import { useHorizontalScroll } from "@/hooks/useHorizontalScroll";
import { PanelFilter, PanelFiltersListProps } from "@/types";

interface RadioFilterListProps extends PanelFiltersListProps {
  filter: PanelFilter;
  name: string;
  border?: boolean;
  classname?: string;
}

const RadioFilterList: FC<RadioFilterListProps> = ({ filter, name, border = true, classname }) => {
  const { valueList, title } = filter;
  const scrollRef = useHorizontalScroll();
  return (
    <>
      {Array.isArray(valueList) && (
        <div className={cn("pt-s pb-m mr-m md:mr-0", border && "border-b border-b-gray-10", classname && classname)}>
          <h4 className="font-primary font-medium text-s mt-xs mb-m uppercase">{title}</h4>
          <div ref={scrollRef} className="flex gap-s overflow-scroll no-scrollbar  -mr-m">
            {valueList.map((filter) => (
              <Radio
                key={filter.value}
                className={cn("search-panel-filter h-[40px]", filter.disabled && "text-gray-10")}
                id={`${title}-${filter.value}`}
                label={filter.label}
                name={name}
                value={filter.value}
                defaultChecked={filter.isSelected && !filter.disabled}
                disabled={filter.disabled}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default RadioFilterList;
